import React, { useEffect, useState } from "react";
import { getAllEnquiryApi, enquirystatus } from "../../api/client";

const Enquiry = () => {
  const [enquiries, setEnquiries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);

  const fetchEnquiries = async () => {
    try {
      const data = await getAllEnquiryApi.getAll();
      if (data.success) setEnquiries(data.data);
    } catch (error) {
      console.error("❌ Error fetching enquiries:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEnquiries();
  }, []);

  // ✅ Update status (backend + UI update)
  const handleStatusChange = async (id, newStatus) => {
    try {
      await enquirystatus.updateStatus(id, newStatus);

      // ✅ UI update
      setEnquiries((prev) =>
        prev.map((item) =>
          item._id === id ? { ...item, status: newStatus } : item
        )
      );
    } catch (error) {
      console.error("❌ Error updating status:", error);
    }
  };

  if (loading) {
    return <p className="text-center text-gray-500">Loading enquiries...</p>;
  }

  // ✅ Filtered Lists
  const pending = enquiries.filter((e) => e.status === "pending");
  const interested = enquiries.filter((e) => e.status === "interested");
  const notInterested = enquiries.filter((e) => e.status === "not_interested");
  const completed = enquiries.filter((e) => e.status === "completed");


  return (
    <div className="max-w-6xl mx-auto p-6">
      <h2 className="text-2xl font-bold mb-6 text-center uppercase">
        All Enquiries
      </h2>

      {/* ================= Pending Enquiries ================= */}
      <h3 className="text-xl font-semibold mb-3 text-yellow-600">
        Pending Enquiries
      </h3>
      {pending.length === 0 ? (
        <p className="text-gray-600 mb-6">No pending enquiries.</p>
      ) : (
        <table className="min-w-full border border-gray-200 mb-8">
          <thead className="bg-gray-100">
            <tr>
              <th className="py-3 px-4 text-left">Name</th>
              <th className="py-3 px-4 text-left">Email</th>
              <th className="py-3 px-4 text-left">Phone</th>
              <th className="py-3 px-4 text-left">Role</th>
              <th className="py-3 px-4 text-left">Status</th>
              <th className="py-3 px-4 text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {pending.map((item) => (
              <tr key={item._id} className="border-b hover:bg-gray-50">
                <td className="py-2 px-4">{item.name}</td>
                <td className="py-2 px-4">{item.email}</td>
                <td className="py-2 px-4">{item.phone}</td>
                <td className="py-2 px-4">{item.role}</td>
                <td className="py-2 px-4 capitalize text-yellow-600">
                  {item.status}
                </td>
                <td className="py-2 px-4 text-center">
                  <button
                    onClick={() => handleStatusChange(item._id, "interested")}
                    className="bg-green-500 text-white px-3 py-1 rounded mr-2 hover:bg-green-600"
                  >
                    Interested
                  </button>
                  <button
                    onClick={() =>
                      handleStatusChange(item._id, "not_interested")
                    }
                    className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
                  >
                    Not Interested
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* ================= Interested Enquiries ================= */}
      <h3 className="text-xl font-semibold mb-3 text-green-700">
        Interested / Updated Enquiries
      </h3>
      {interested.length === 0 ? (
        <p className="text-gray-600">No interested enquiries yet.</p>
      ) : (
        <table className="min-w-full border border-gray-200 mb-8">
          <thead className="bg-gray-100">
            <tr>
              <th className="py-3 px-4 text-left">Name</th>
              <th className="py-3 px-4 text-left">Email</th>
              <th className="py-3 px-4 text-left">Phone</th>
              <th className="py-3 px-4 text-left">Role</th>
              <th className="py-3 px-4 text-left">Status</th>
              <th className="py-3 px-4 text-center">Change Status</th>
              <th className="py-3 px-4 text-center">View</th>
            </tr>
          </thead>
          <tbody>
            {interested.map((item) => (
              <tr key={item._id} className="border-b hover:bg-gray-50">
                <td className="py-2 px-4">{item.name}</td>
                <td className="py-2 px-4">{item.email}</td>
                <td className="py-2 px-4">{item.phone}</td>
                <td className="py-2 px-4">{item.role}</td>
                <td className="py-2 px-4 capitalize text-green-600">
                  {item.status}
                </td>
                {/* *********Change Status******* */}
                <td className="py-2 px-4 text-center">
                  <select
                    value={item.status}
                    onChange={(e) =>
                      handleStatusChange(item._id, e.target.value)
                    }
                    className="border rounded px-2 py-1 text-sm"
                  >
                    <option value="interested">Interested</option>
                    <option value="not_interested">Not Interested</option>
                    <option value="completed">Completed</option>
                  </select>
                </td>
                <td className="py-2 px-4 text-center">
                  <button
                    onClick={() => setSelected(item)}
                    className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
                  >
                    View
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* Completed *********************** */}
      <h3 className="text-xl font-semibold mb-3 text-blue-700">
        Completed Enquiries
      </h3>
      {completed.length === 0 ? (
        <p className="text-gray-600">No Completed enquiries.</p>
      ) : (
        <table className="min-w-full border border-gray-200">
          <thead className="bg-gray-100">
            <tr>
              <th className="py-3 px-4 text-left">Name</th>
              <th className="py-3 px-4 text-left">Email</th>
              <th className="py-3 px-4 text-left">Phone</th>
              <th className="py-3 px-4 text-left">Role</th>
              <th className="py-3 px-4 text-left">Status</th>
              <th className="py-3 px-4 text-center">View</th>
            </tr>
          </thead>
          <tbody>
            {completed.map((item) => (
              <tr key={item._id} className="border-b hover:bg-gray-50">
                <td className="py-2 px-4">{item.name}</td>
                <td className="py-2 px-4">{item.email}</td>
                <td className="py-2 px-4">{item.phone}</td>
                <td className="py-2 px-4">{item.role}</td>
                <td className="py-2 px-4 text-blue-700 font-semibold capitalize">
                  {item.status.replace("_", " ")}
                </td>
                <td className="py-2 px-4 text-center">
                  <button
                    onClick={() => setSelected(item)}
                    className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
                  >
                    View
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* ✅ same popup view as before */}
      {selected && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex justify-center items-center z-50">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg p-6 relative border border-gray-100">
            <button
              onClick={() => setSelected(null)}
              className="absolute top-3 right-4 text-gray-400 hover:text-red-600 text-2xl font-bold transition-all"
            >
              ✕
            </button>
            <h3 className="text-2xl font-semibold mb-5 text-center text-blue-700 border-b pb-2">
              Enquiry Details
            </h3>
            <div className="space-y-4 text-gray-700 text-sm">
              <p>
                <strong>Name:</strong> {selected.name}
              </p>
              <p>
                <strong>Email:</strong> {selected.email}
              </p>
              <p>
                <strong>Phone:</strong> {selected.phone}
              </p>
              <p>
                <strong>Role:</strong> {selected.role}
              </p>
              <p>
                <strong>Description:</strong> {selected.description || "N/A"}
              </p>
              <p>
                <strong>Status:</strong> {selected.status}
              </p>
            </div>
          </div>
        </div>
      )}

      {/* ================= Not Interested Enquiries ================= */}
      <h3 className="text-xl font-semibold mb-3 text-red-700 mt-7">
        Not Interested Enquiries
      </h3>
      {notInterested.length === 0 ? (
        <p className="text-gray-600">No not interested enquiries.</p>
      ) : (
        <table className="min-w-full border border-gray-200">
          <thead className="bg-gray-100">
            <tr>
              <th className="py-3 px-4 text-left">Name</th>
              <th className="py-3 px-4 text-left">Email</th>
              <th className="py-3 px-4 text-left">Phone</th>
              <th className="py-3 px-4 text-left">Role</th>
              <th className="py-3 px-4 text-left">Status</th>
              <th className="py-3 px-4 text-left">Change Status</th>
              <th className="py-3 px-4 text-center">View</th>
            </tr>
          </thead>
          <tbody>
            {notInterested.map((item) => (
              <tr key={item._id} className="border-b hover:bg-gray-50">
                <td className="py-2 px-4">{item.name}</td>
                <td className="py-2 px-4">{item.email}</td>
                <td className="py-2 px-4">{item.phone}</td>
                <td className="py-2 px-4">{item.role}</td>
                <td className="py-2 px-4 text-red-600 capitalize">
                  {item.status.replace("_", " ")}
                </td>
                <td className="py-2 px-4 text-center">
                  <select
                    value={item.status}
                    onChange={(e) =>
                      handleStatusChange(item._id, e.target.value)
                    }
                    className="border rounded px-2 py-1 text-sm"
                  >
                    <option value="interested">Interested</option>
                    <option value="not_interested">Not Interested</option>
                    <option value="completed">Completed</option>
                    {/* <option value="pending">Pending</option> */}
                  </select>
                </td>
                <td className="py-2 px-4 text-center">
                  <button
                    onClick={() => setSelected(item)}
                    className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
                  >
                    View
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default Enquiry;
